import { faClose } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import React, { useEffect, useRef } from "react";

import Button, { ButtonVariantEnum } from "@/components/atoms/forms/Button";
import { SizeEnum } from "@/enums";
import { useScreenSize } from "@/hooks";
import useScrollLock from "@/hooks/useScrollLock";

import styles from "./Popup.module.css";

interface Props {
  open: boolean;
  anchorEl: React.RefObject<HTMLElement | null>;
  centerPopup?: boolean;
  title: string;
  children: React.ReactNode;
  close: () => void;
}

const Popup = ({
  open,
  anchorEl,
  centerPopup,
  title,
  children,
  close,
}: Props) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const { isMaxLg } = useScreenSize();
  useScrollLock(open && isMaxLg);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const isInsideFieldset = anchorEl.current?.contains(target);
      const isInsidePopup = popupRef.current?.contains(target);

      if (isInsideFieldset) return;

      if (!isInsidePopup) {
        close();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl, close]);

  return (
    <div
      ref={popupRef}
      className={clsx(styles.popup, centerPopup && styles.popupCenter)}
      data-open={open}
    >
      <section className={styles.popupHeader}>
        <span>{title}</span>
        <Button
          icon={faClose}
          rounded
          size={SizeEnum.LARGE}
          variant={ButtonVariantEnum.PLAIN}
          onClick={close}
        />
      </section>
      {children}
    </div>
  );
};

export default Popup;
